import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { BadgePriority } from './types';

const hasPriority = async (
  base: UniDriver,
  priority: BadgePriority,
): Promise<boolean> => {
  const priorityVale = await base.attr('data-priority');
  return priorityVale === priority;
};

const isIconExists = async (base: UniDriver): Promise<boolean> => {
  return !!base.$(`[data-hook=badge-icon] svg`);
};

export interface BadgeDriver extends BaseUniDriver {
  isPrimary(): Promise<boolean>;
  isLight(): Promise<boolean>;
  isDefault(): Promise<boolean>;
  isSecondary(): Promise<boolean>;
  hasIcon(): Promise<boolean>;
}

export const badgeDriverFactory = (base: UniDriver): BadgeDriver => {
  return {
    ...baseUniDriverFactory(base),
    isPrimary: () => hasPriority(base, BadgePriority.primary),
    isLight: () => hasPriority(base, BadgePriority.light),
    isDefault: () => hasPriority(base, BadgePriority.default),
    isSecondary: () => hasPriority(base, BadgePriority.secondary),
    hasIcon: () => isIconExists(base),
  };
};
